import * as yup from "yup";

// Extracted validation functions - now testable!
export const zipcodeRequiredValidator = (value) => {
  return !!value;
};

export const zipcodeFormatValidator = (value) => {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
};

// Main validation schema factory
export const createEventValidationSchema = () => {
  return yup.object({
    name: yup.string().trim().required("Name is required"),
    squareLocation: yup.string().trim().required("Square Location is required"),
    placeName: yup.string().trim().required("Location Name is required"),
    addressLine1: yup.string().trim().required("Address Line 1 is required"),
    addressLine2: yup.string().trim(),
    city: yup.string().trim().required("City is required"),
    state: yup.string().trim().required("State is required"),
    zipcode: yup
      .mixed()
      .test("required", "ZIP code is required", zipcodeRequiredValidator)
      .test("valid", "ZIP code must be valid", zipcodeFormatValidator),
    startsAtDate: yup
      .date("Invalid Date")
      .typeError("Invalid Date")
      .required("Start Date is required"),
    startsAtTime: yup
      .date("Invalid Time")
      .typeError("Invalid Time")
      .required("Start Time is required"),
    endsAtDate: yup
      .date("Invalid Date")
      .typeError("Invalid Date")
      .required("End Date is required"),
    endsAtTime: yup
      .date("Invalid Time")
      .typeError("Invalid Time")
      .required("End Time is required"),
    timezone: yup.string().required("Time Zone is required"),
  });
};
